$(document).ready(function() {
    $('.product-form__submit[name="add"]').attr("disabled", true);

    function getFilterClasses(index, classNames) {
        var current_classes = classNames.split(" "), classes_to_remove = []; 
        
        $.each(current_classes, function (index, class_name) {
          if (/^filter-.*/.test(class_name)) {classes_to_remove.push(class_name);}
        });
    
        return classes_to_remove.join(" ");
    }

    function getLayoutClasses(index, classNames) {
        var current_classes = classNames.split(" "), classes_to_remove = []; 
        
        $.each(current_classes, function (index, class_name) {
          if (/^layout-.*/.test(class_name)) {classes_to_remove.push(class_name);}
        });
    
        return classes_to_remove.join(" ");
    }

    // Restore saved text
    var savedHeading = localStorage.getItem('ptp-heading');
    var savedSubheading = localStorage.getItem('ptp-subheading');
    if (savedHeading) {
        $('#bp-photo-heading').val(savedHeading);
        $('.bp-poster-headline .bp-photo-heading').text(savedHeading);
    }
    if (savedSubheading) {
        $('#bp-photo-subheading').val(savedSubheading);
        $('.bp-poster-subheading .bp-photo-subheading').text(savedSubheading);
    }

    $('#bp-photo-heading').on('input change', function(){
        let heading = $(this).val();

        // Only the default font is set in caps. Playfair and Medusa are chosen
        // for their lowercase shapes -- Medusa's connecting glyphs don't exist
        // in uppercase at all -- so forcing toUpperCase() here would defeat
        // them no matter what CSS the font picker applies.
        var _font = ($('#bp-heading-font-1').val() || 'default');
        var _cased = (_font === 'default') ? heading.toUpperCase() : heading;

        $(this).val(_cased);
        $('.bp-poster-headline .bp-photo-heading').text(_cased);
        localStorage.setItem('ptp-heading', _cased)
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-headline');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('#bp-photo-subheading').on('input change', function(){
        let subheading = $(this).val();

        $(this).val(subheading.toUpperCase());
        $('.bp-poster-subheading .bp-photo-subheading').text(subheading.toUpperCase());
        localStorage.setItem('ptp-subheading', subheading.toUpperCase())
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-subheading');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    // Background color change
    function getBrightness(hex) {
        hex = hex.replace('#', '');
        var r = parseInt(hex.substring(0, 2), 16);
        var g = parseInt(hex.substring(2, 4), 16);
        var b = parseInt(hex.substring(4, 6), 16);
        return (r * 299 + g * 587 + b * 114) / 1000;
    }

    $('.bp-background-radio').on('change', function() {
        var color = $(this).attr('data-color');
        var name = $(this).attr('data-name');
        $('.bp-bg-selected-value').text(name);
        $('.bp-poster-preview').css('background-color', color);
        localStorage.setItem('ptp-bg-color', color);

        var brightness = getBrightness(color);
        var textColor = brightness > 128 ? '#1a1a1a' : '#f5f5f5';
        $('.bp-poster-info').css('color', textColor);
    });

    // Restore saved background
    var savedBg = localStorage.getItem('ptp-bg-color');
    if (savedBg) {
        $('.bp-background-radio[data-color="' + savedBg + '"]').prop('checked', true);
    }
    $('.bp-background-radio:checked').change();

    // ─── URL param pre-fill (for product template links) ───
    // Supports: ?filter=golden&heading=Sunny&subheading=Our+Happy+Boy&bg=%23FFFFFF
    (function applyUrlParams() {
        var params = new URLSearchParams(window.location.search);
        var urlFilter = params.get('filter');
        var urlHeading = params.get('heading');
        var urlSubheading = params.get('subheading');
        var urlBg = params.get('bg');

        if (urlHeading) {
            var h = urlHeading.toUpperCase();
            $('#bp-photo-heading').val(h).trigger('input');
        }
        if (urlSubheading) {
            var s = urlSubheading.toUpperCase();
            $('#bp-photo-subheading').val(s).trigger('input');
        }
        if (urlFilter && urlFilter !== 'original') {
            // Delay slightly to ensure filter thumbnails are ready
            setTimeout(function() {
                var radio = $('.ptp-filter-radio[value="' + urlFilter + '"]');
                if (radio.length) {
                    radio.prop('checked', true).trigger('change');
                }
            }, 500);
        }
        if (urlBg) {
            var bgRadio = $('.bp-background-radio[data-color="' + urlBg + '"]');
            if (bgRadio.length) {
                bgRadio.prop('checked', true).trigger('change');
            }
        }

        // Clean URL params after applying (so they don't persist on refresh)
        if (urlFilter || urlHeading || urlSubheading || urlBg) {
            window.history.replaceState({}, '', window.location.pathname);
        }
    })();

    // Fill poster toggle
    $('#bp-fill-poster-toggle').on('change', function() {
        if ($(this).is(':checked')) {
            $('.petposter-template').addClass('fill-poster');
        } else {
            $('.petposter-template').removeClass('fill-poster');
        }
    });

    // Orientation toggle
    window.ptpSetOrientation = function(orient) {
        $('.ptp-orient-btn').removeClass('active');
        $('.ptp-orient-btn[data-orient="' + orient + '"]').addClass('active');
        $('#ptp-orientation-value').val(orient === 'landscape' ? 'Landscape' : 'Portrait');

        $('.petposter-template').removeClass('bp_portrait bp_landscape');
        $('.petposter-template').addClass('bp_' + orient);

        $('.hidden-preview').removeClass('bp_portrait bp_landscape');
        $('.hidden-preview').addClass('bp_' + orient);

        // Re-trigger frame to swap portrait/landscape image
        setTimeout(function() {
            $('.bp-frame-radio:checked').trigger('change');
        }, 50);

        localStorage.setItem('ptp-orientation', orient);
    };

    // Restore saved orientation (delayed to let frames load first)
    var savedOrient = localStorage.getItem('ptp-orientation');
    if (savedOrient === 'landscape') {
        setTimeout(function() {
            window.ptpSetOrientation('landscape');
        }, 500);
    }

    // Canvas-based filter system
    var ptpOriginalCanvas = null; // stores the original cropped image as a canvas
    var ptpCurrentFilter = 'original';
    var ptpCurrentStrength = 100;

    // Global setter for photo library to set the canvas
    window.ptpSetOriginalCanvas = function(canvas, width, height) {
        ptpOriginalCanvas = canvas;
        ptpImageWidth = width || canvas.width;
        ptpImageHeight = height || canvas.height;
        ptpCurrentFilter = 'original';
        $('.ptp-filter-radio[value="original"]').prop('checked', true);
        ptpUpdateQuality();
    };

    // Initialize canvas from default mockup image
    var defaultImg = new Image();
    defaultImg.crossOrigin = 'anonymous';
    defaultImg.onload = function() {
        var c = document.createElement('canvas');
        c.width = defaultImg.width;
        c.height = defaultImg.height;
        c.getContext('2d').drawImage(defaultImg, 0, 0);
        ptpOriginalCanvas = c;
    };
    defaultImg.src = $('.bp-illustration-img').attr('src');

    function ptpApplyCurrentFilter() {
        if (!ptpOriginalCanvas || !window.ptpFilterEngine) return;
        var resultCanvas = window.ptpFilterEngine.applyFilter(ptpOriginalCanvas, ptpCurrentFilter, ptpCurrentStrength);
        var dataUrl = resultCanvas.toDataURL('image/jpeg', 0.92);
        $('.bp-illustration-img').attr('src', dataUrl);
        $('.bp-illustration-filter-img').attr('src', dataUrl);

        // Update the cropped_photo file input with the filtered image for cart submission
        resultCanvas.toBlob(function(blob) {
            if (blob) {
                var file = new File([blob], 'filtered-photo.jpg', { type: 'image/jpeg' });
                var dt = new DataTransfer();
                dt.items.add(file);
                var croppedInput = document.getElementById('cropped_photo');
                if (croppedInput) croppedInput.files = dt.files;
                window.ptpUploadedFile = file;
            }
        }, 'image/jpeg', 0.92);
    }

    $(document).on('change', '.ptp-filter-radio', function(){
        ptpCurrentFilter = $(this).val();
        localStorage.setItem('ptp-selected-filter', ptpCurrentFilter);

        if(ptpCurrentFilter === 'original') {
            $('.ptp-filter-range').attr("disabled", true);
            $('.ptp-filter-range').val(100);
            ptpCurrentStrength = 100;
        } else {
            $('.ptp-filter-range').attr("disabled", false);
            var val = localStorage.getItem($('.ptp-filter-range').attr("name")) || 100;
            $('.ptp-filter-range').val(val);
            ptpCurrentStrength = parseInt(val);
        }

        localStorage.setItem('ptp-filter-strength', ptpCurrentStrength);
        ptpApplyCurrentFilter();
    });

    $('.ptp-filter-range').on('input change', function(){
        var val = parseInt($(this).val());
        ptpCurrentStrength = val;
        $('.ptp-filter-range-value').text(val + '%');
        localStorage.setItem('ptp-filter-strength', val);
        ptpApplyCurrentFilter();
    });

    // Direct upload — no cropper modal
    var directUpload = document.getElementById('ptp-direct-upload');
    var ptpImageWidth = 0;
    var ptpImageHeight = 0;
    var ptpPanX = 0;
    var ptpPanY = 0;
    var ptpDragEnabled = false;

    if (directUpload) {
        directUpload.addEventListener('change', function(e) {
            if (e.target.files.length > 0) {
                ptpLoadImage(e.target.files[0]);
            }
        });
    }

    $('.bp-start-over-btn').on('click', function() {
        if (directUpload) directUpload.click();
    });

    async function ptpLoadImage(file) {
        var maxFileSize = 50 * 1024 * 1024;
        if (file.size > maxFileSize) {
            alert('Image too large (max 50MB)');
            return;
        }

        if (file.type === 'image/heic') {
            try {
                var blob = await heic2any({ blob: file, toType: 'image/jpeg' });
                file = new File([blob], file.name.replace(/\.[^/.]+$/, '.jpg'), { type: 'image/jpeg' });
            } catch (err) {
                console.error('HEIC conversion error:', err);
                return;
            }
        }

        var objectURL = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function() {
            ptpImageWidth = img.width;
            ptpImageHeight = img.height;
            ptpPanX = 0;
            ptpPanY = 0;

            $('.bp-illustration-img').attr('src', objectURL);
            $('.bp-illustration-filter-img').attr('src', objectURL);
            $('.bp-upload-overlay').addClass('hide');

            // Set cropped photo input for cart submission
            var dt = new DataTransfer();
            dt.items.add(file);
            var croppedInput = document.getElementById('cropped_photo');
            if (croppedInput) croppedInput.files = dt.files;

            var c = document.createElement('canvas');
            c.width = img.width;
            c.height = img.height;
            c.getContext('2d').drawImage(img, 0, 0);
            ptpOriginalCanvas = c;
            ptpCurrentFilter = 'original';
            $('.ptp-filter-radio[value="original"]').prop('checked', true);

            if (window.ptpFilterEngine) {
                window.ptpFilterEngine.generateThumbnails(img, function(filterId, dataUrl) {
                    var preview = document.querySelector('.ptp-filter-preview[data-filter-id="' + filterId + '"]');
                    if (preview) preview.style.backgroundImage = 'url(' + dataUrl + ')';
                });
            }

            window.ptpUploadedImageUrl = objectURL;
            window.ptpUploadedFile = file;
            ptpUpdateQuality();
            $('.product-form__submit[name="add"]').attr('disabled', false);
            $('.bp-save-for-later-btn').removeClass('hide');
            $('.bp-frame-radio:checked').change();
        };
        img.src = objectURL;
    }

    function ptpUpdateQuality() {
        if (!ptpImageWidth) return;
        var sizeStr = $('#bp-size-dropdown').val() || '';
        var match = sizeStr.match(/(\d+)x(\d+)/);
        if (!match) return;
        var printW = parseInt(match[1]);
        var printH = parseInt(match[2]);
        var dpiW = ptpImageWidth / (printW / 2.54);
        var dpiH = ptpImageHeight / (printH / 2.54);
        var dpi = Math.min(dpiW, dpiH);
        var level = dpi >= 300 ? 5 : dpi >= 200 ? 4 : dpi >= 150 ? 3 : dpi >= 100 ? 2 : 1;
        $('.ptp-quality-dot').each(function(i) {
            $(this).toggleClass('active', i < level);
        });
    }

    $(document).on('change', '#bp-size-dropdown', function() {
        ptpUpdateQuality();
    });

    // Adjust Image — constrained drag-to-pan
    window.ptpToggleAdjust = function() {
        ptpDragEnabled = !ptpDragEnabled;
        $('#ptp-adjust-btn').toggleClass('active', ptpDragEnabled);
        $('.petposter-template').toggleClass('ptp-adjusting', ptpDragEnabled);

        if (ptpDragEnabled) {
            // Show drag instruction overlay
            var overlay = document.getElementById('ptp-drag-overlay');
            if (overlay) {
                overlay.classList.add('active');
                setTimeout(function() { overlay.classList.remove('active'); }, 2500);
            }
        }
    };

    function ptpGetPanConstraints() {
        var container = $('.bp-preview-illustration')[0];
        if (!container || !ptpImageWidth) return { minX: 0, maxX: 0, minY: 0, maxY: 0 };
        var contW = container.offsetWidth;
        var contH = container.offsetHeight;
        var imgAspect = ptpImageWidth / ptpImageHeight;
        var contAspect = contW / contH;
        var imgDisplayW, imgDisplayH;
        if (imgAspect > contAspect) {
            imgDisplayH = contH;
            imgDisplayW = contH * imgAspect;
        } else {
            imgDisplayW = contW;
            imgDisplayH = contW / imgAspect;
        }
        var maxPanX = Math.max(0, (imgDisplayW - contW) / 2);
        var maxPanY = Math.max(0, (imgDisplayH - contH) / 2);
        return { minX: -maxPanX, maxX: maxPanX, minY: -maxPanY, maxY: maxPanY };
    }

    (function() {
        var isDragging = false;
        var startX, startY, startPanX, startPanY;
        var illustration = null;

        $(document).on('mousedown touchstart', '.ptp-adjusting .bp-preview-illustration', function(e) {
            if (!ptpDragEnabled) return;
            isDragging = true;
            illustration = $('.bp-illustration-img, .bp-illustration-filter-img');
            var evt = e.type === 'touchstart' ? e.originalEvent.touches[0] : e;
            startX = evt.clientX;
            startY = evt.clientY;
            startPanX = ptpPanX;
            startPanY = ptpPanY;
            e.preventDefault();
        });

        $(document).on('mousemove touchmove', function(e) {
            if (!isDragging) return;
            var evt = e.type === 'touchmove' ? e.originalEvent.touches[0] : e;
            var constraints = ptpGetPanConstraints();
            ptpPanX = Math.max(constraints.minX, Math.min(constraints.maxX, startPanX + (evt.clientX - startX)));
            ptpPanY = Math.max(constraints.minY, Math.min(constraints.maxY, startPanY + (evt.clientY - startY)));
            illustration.css('object-position', 'calc(50% + ' + ptpPanX + 'px) calc(50% + ' + ptpPanY + 'px)');
            e.preventDefault();
        });

        $(document).on('mouseup touchend', function() {
            if (isDragging) {
                isDragging = false;
                // Show "Done" feedback
                var btn = $('#ptp-adjust-btn');
                btn.find('span').text('✓ DONE');
                btn.addClass('ptp-done');
                setTimeout(function() {
                    btn.find('span').text('ADJUST');
                    btn.removeClass('ptp-done');
                    ptpDragEnabled = false;
                    btn.removeClass('active');
                    $('.petposter-template').removeClass('ptp-adjusting');
                }, 1500);
            }
        });
    })();

    // Resize image for API calls
    function ptpResizeForAPI(file, maxSize) {
        return new Promise(function(resolve) {
            var img = new Image();
            img.onload = function() {
                var w = img.width, h = img.height;
                var scale = maxSize / Math.max(w, h);
                if (scale >= 1) scale = 1;
                var nw = Math.round(w * scale), nh = Math.round(h * scale);
                var c = document.createElement('canvas');
                c.width = nw; c.height = nh;
                c.getContext('2d').drawImage(img, 0, 0, nw, nh);
                resolve(c.toDataURL('image/jpeg', 0.85));
            };
            img.src = URL.createObjectURL(file);
        });
    }

    // Resize from canvas for API
    function ptpResizeCanvasForAPI(canvas, maxSize) {
        var w = canvas.width, h = canvas.height;
        var scale = maxSize / Math.max(w, h);
        if (scale >= 1) scale = 1;
        var nw = Math.round(w * scale), nh = Math.round(h * scale);
        var c = document.createElement('canvas');
        c.width = nw; c.height = nh;
        c.getContext('2d').drawImage(canvas, 0, 0, nw, nh);
        return c.toDataURL('image/jpeg', 0.85);
    }

    // Auto Design
    window.ptpAutoDesign = async function() {
        if (!ptpOriginalCanvas && !window.ptpUploadedFile) {
            alert('Please upload a photo first');
            return;
        }

        var btn = $('#ptp-auto-design-btn');
        var loader = document.getElementById('ptp-design-loader');
        btn.addClass('loading');
        btn.find('span').text('...');
        if (loader) loader.classList.add('active');

        try {
            var dataUrl;
            if (window.ptpUploadedFile) {
                dataUrl = await ptpResizeForAPI(window.ptpUploadedFile, 1024);
            } else if (ptpOriginalCanvas) {
                dataUrl = ptpResizeCanvasForAPI(ptpOriginalCanvas, 1024);
            }

            var resp = await fetch('https://petposter.vercel.app/api/auto-design', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ imageUrl: dataUrl })
            });

            var data = await resp.json();
            if (!resp.ok) throw new Error(data.error || 'Failed');

            if (data.heading) {
                $('#bp-photo-heading').val(data.heading).trigger('input');
            }
            if (data.subheading) {
                $('#bp-photo-subheading').val(data.subheading).trigger('input');
            }
            if (data.filter) {
                $('.ptp-filter-radio[value="' + data.filter + '"]').prop('checked', true).trigger('change');
            }
            if (data.backgroundColor) {
                $('.bp-background-radio[data-color="' + data.backgroundColor + '"]').prop('checked', true).trigger('change');
            }
        } catch (err) {
            console.error('Auto-design error:', err);
            alert('Could not analyze photo. Please try again.');
        } finally {
            btn.removeClass('loading');
            btn.find('span').text('AUTO');
            if (loader) loader.classList.remove('active');
        }
    };
});